module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/logo_mrso-d4e3c7dc217dbfe5ddd1dcb156ed418d.svg";